import { useState } from 'react';

import Button from 'honeydew/Button';
import Checkbox from 'honeydew/Checkbox';
import DrawerModal from 'shared/DrawerModal';

/**
 * Confirmation modal displayed after a user adds a product to their recurring items list.
 * This modal is informational - the action has already occurred.
 * Includes a checkbox to suppress future displays of this modal.
 *
 * @param {Object} props
 * @param {boolean} [props.isOpen=false] - Whether the modal is open
 * @param {string} [props.itemName] - The name of the product that was added
 * @param {Function} props.onClose - Callback when modal is closed, receives suppressFutureModals boolean
 */
export function AddToRecurringModal({ isOpen = false, itemName, onClose }) {
    const [suppressFutureModals, setSuppressFutureModals] = useState(false);

    const handleClose = () => {
        onClose(suppressFutureModals);
        setSuppressFutureModals(false);
    };

    if (!isOpen) {
        return null;
    }

    const displayName = itemName || 'this item';

    return (
        <DrawerModal
            onClose={handleClose}
            drawerProps={{
                sx: { zIndex: 6000 },
            }}
            modalProps={{
                centered: true,
                styles: { contentRoot: 'py-40 px-60' },
                includeHorizontalPadding: false,
            }}
        >
            <div className="flex flex-col">
                <h2 className="text-heading-xs mb-15 md:mb-10">Added to Recurring</h2>
                <p className="mb-15 text-body-mobile-sm md:mb-20 md:text-body-mobile-md">
                    We&apos;ve added <span className="font-grotesk-bold">{displayName}</span> to your recurring list.
                    <br />
                    <br />
                    We&apos;ll automatically add it to your cart so you never forget your favorites. Recurring items are
                    charged in addition to your pre-filled cart (and are subject to availability!).
                </p>
                <Checkbox
                    id="suppress-recurring-modal"
                    label="Don't show me this again"
                    labelStyle="small"
                    checked={suppressFutureModals}
                    onCheckedChange={setSuppressFutureModals}
                    styles={{ label: 'text-body-sm' }}
                    wrapperClassName="mb-20"
                />
                <Button variant="primary" onClick={handleClose}>
                    Got it
                </Button>
            </div>
        </DrawerModal>
    );
}
